// Constants
import {
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  LOAD_APPS_REQUEST,
  LOAD_APPS_SUCCESS,
  CUSTOMER_REQUEST,
  CUSTOMER_SUCCESS,
  GET_MARKETS_REQUEST,
  GET_MARKETS_SUCCESS,
  GET_MARKETS_ERROR,
  CUSTOMER_APPLY_REQUEST,
  CUSTOMER_APPLY_SUCCESS,
  APPLICANT_RESPONSE_ERROR,
  CUSTOMER_RESPONSE_ERROR
} from '../constants'

const initialState = {
  count: 0
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SIGN_IN_REQUEST:
    case LOAD_APPS_REQUEST:
    case CUSTOMER_REQUEST:
    case GET_MARKETS_REQUEST:
    case CUSTOMER_APPLY_REQUEST: {
      return {
        count: state.count + 1
      }
    }

    case SIGN_IN_SUCCESS:
    case LOAD_APPS_SUCCESS:
    case CUSTOMER_SUCCESS:
    case GET_MARKETS_SUCCESS:
    case GET_MARKETS_ERROR:
    case CUSTOMER_APPLY_SUCCESS:
    case APPLICANT_RESPONSE_ERROR:
    case CUSTOMER_RESPONSE_ERROR: {
      const temp = state.count - 1
      const count = temp < 0 ? 0 : temp

      return {
        count
      }
    }

    default:
      return state
  }
}

export const selectLoading = ({ requests }) => requests.count > 0
